import script from "./CsaRibbon.vue?vue&type=script&setup=true&lang=js"
export * from "./CsaRibbon.vue?vue&type=script&setup=true&lang=js"

import "./CsaRibbon.vue?vue&type=style&index=0&id=d68f152a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d68f152a"]])

export default __exports__